import DateFnsUtils from '@date-io/date-fns';
import '@fontsource/roboto';
import {
  AuthorizationService,
  CalculationService,
  FileAccessService,
  DocumentService,
  EventService,
  ExportService,
  getBrowserAuthClients,
  LookupService,
} from '@price-for-profit/micro-services';
import { LocalizationProvider } from '@mui/lab';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ProvideAuth, ProvideQueryClient, ProvideService, ProvideSnackbar, ProvideTheme } from 'shared/providers';
import { QuoteService, UserService } from 'shared/services';
import { getAppConfig } from 'startup/get-app-config';
import { registerGoogleAnalytics } from 'startup/register-google-analytics';
import App from './App';
import './index.css';
import { getInsightEnvironment, initSplunk } from 'startup/init-splunk';

//import reportWebVitals from './reportWebVitals';
const run = async () => {
  const baseUrl = process.env.PUBLIC_URL;
  const appConfig = await getAppConfig(baseUrl);
  const env = getInsightEnvironment({ serviceBaseUrl: appConfig.serviceBaseUrl });

  const { clientApp, httpClient } = getBrowserAuthClients({
    clientId: appConfig.appId,
    authDomainHost: appConfig.authDomainHost,
    authorityUrl: appConfig.authorityUrl,
    cacheLocation: 'sessionStorage',
    serviceBaseUrl: appConfig.serviceBaseUrl,
    clientScopes: {
      docs: appConfig.documentAppId,
      ces: appConfig.calculationAppId,
      lookup: appConfig.lookupAppId,
      export: appConfig.exportAppId,
      auth: appConfig.authAppId,
      event: appConfig.eventAppId,
      fas: appConfig.fileAccessAppId,
    },
  });

  const lookupService = new LookupService(httpClient);
  const documentService = new DocumentService(httpClient);
  const exportService = new ExportService(httpClient);
  const calculationService = new CalculationService(httpClient);
  const eventService = new EventService(httpClient);
  const authService = new AuthorizationService(httpClient);
  const fileAccessService = new FileAccessService(httpClient);

  const quoteService = new QuoteService(
    fileAccessService,
    documentService,
    calculationService,
    exportService,
    lookupService
  );
  const userService = new UserService(authService, lookupService, eventService);

  const serviceContext = {
    appConfig,
    quoteService,
    userService,
  };

  if (appConfig.enableGoogleAnalytics) {
    registerGoogleAnalytics(appConfig.googleTagId);
  }

  console.log('Checking for splunkRumAccessToken...');
  if (appConfig.splunkRumAccessToken) {
    console.log('splunkRumAccessToken found. Initializing splunk...');
    initSplunk(appConfig, env);
  }

  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter basename={baseUrl}>
        <ProvideTheme>
          <ProvideSnackbar>
            <ProvideService context={serviceContext}>
              <ProvideAuth clientApp={clientApp}>
                <ProvideQueryClient>
                  <LocalizationProvider dateAdapter={DateFnsUtils}>
                    <App />
                  </LocalizationProvider>
                </ProvideQueryClient>
              </ProvideAuth>
            </ProvideService>
          </ProvideSnackbar>
        </ProvideTheme>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

run().catch(console.error);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
